export function parseApiErrorMessage(
  error: any,
  defaultMessage: string = 'An error occurred'
): string {
  if (typeof error?.response?.data?.message === 'string') {
    return error.response.data.message;
  }
  return defaultMessage;
}
